import { Epic } from 'interfaces/middleware'
import { combineEpics } from 'redux-observable'
import { REGISTER_SHARE } from 'actions/socialActions'
import { generateShareUrl } from 'helpers/socialHelpers'
import { IS_STATUS_APP } from 'helpers/userAgentHelpers'
import { SHARE_POPUP_PARAMS } from 'constants/media'
import { byType } from 'rxOperators/byType'
import { end } from 'rxOperators/end'

const shareEpic: Epic = (action$, _store, { remote }) =>
  action$
    .pipe(byType(REGISTER_SHARE))
    .pipe(end(({ payload }) => {
      const { method } = payload
      if (method === 'native') {
        remote.sendShareEvent(payload as any)
      } else if (method !== 'email') {
        if (IS_STATUS_APP) {
          const url = generateShareUrl(payload)
          if (url) {
            remote.sendExternalUrlEvent({ url })
          }
        } else {
          window.open(generateShareUrl(payload), '_blank', SHARE_POPUP_PARAMS)
        }
      }
    }))

export default combineEpics(
  shareEpic,
)
